import { useCallback, useEffect } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { VaultFileSelector } from '@/dialogs/AddMediaDialog/VaultFileSelector.tsx'
import {
  resetFilesToAdd,
  uploadAllMediaFx,
} from '@/dialogs/AddMediaDialog/models.ts'
import type { DialogProps } from '@/dialogs/types'

interface Props extends DialogProps {
  selectedCategoryId?: number
}

export const AddMediaDialog = ({
  isOpen,
  onClose,
  selectedCategoryId,
}: Props) => {
  const loading = useUnit(uploadAllMediaFx.pending)

  useEffect(() => {
    if (isOpen) {
      resetFilesToAdd()
    }
  }, [isOpen])

  const handleContinue = useCallback(async () => {
    try {
      await uploadAllMediaFx(selectedCategoryId)
      onClose()
    } catch {
      // Do nothing
    }
  }, [onClose, selectedCategoryId])

  return (
    <Dialog
      rootClassName="bg-secondary-900/50"
      containerClassName="pointer-events-auto"
      show={isOpen}
    >
      <Dialog.Header>
        <Dialog.Title>Add Media</Dialog.Title>
      </Dialog.Header>

      <div className="my-5">
        <VaultFileSelector />
      </div>

      <Dialog.Footer className="grid grid-cols-2 gap-2">
        <Button
          disabled={loading}
          onClick={onClose}
          variant="outline"
        >
          Cancel
        </Button>
        <Button
          isLoading={loading}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
